import { render, staticRenderFns } from "./internalTransferRequests.vue?vue&type=template&id=4da6db5f&"
import script from "./internalTransferRequests.vue?vue&type=script&lang=js&"
export * from "./internalTransferRequests.vue?vue&type=script&lang=js&"
import style0 from "./internalTransferRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports